import * as yup from "yup";
import { BASIC_AUTHENTICATION_ERROR } from "../constants/errorMessages";
import REGEX from "../constants/constants";

const { EMAIL_PATTERN } = REGEX;

export const newsletterSchema = yup.object({
  email: yup
    .string()
    .required("Email is required")
    .matches(EMAIL_PATTERN, BASIC_AUTHENTICATION_ERROR.EMAIL)
    .max(254, BASIC_AUTHENTICATION_ERROR.MSG_EMAIL_LENGTH),
});
